import "./App.css";

const Header = () => {
  return (
    <div className="header-container">
      <header className="header">
        <div className="college-info">
          <img
            src="https://payformservices.nttdatapay.com/logos/ladyirwin/college_logo.jpg"
            alt="College Logo"
            className="college-logo"
          />
          <div className="college-details">
            <h1>LADY IRWIN COLLEGE</h1>
            <p>
              UNIVERSITY OF DELHI, SIKANDRA RD, MANDI HOUSE, NEW DELHI, DELHI
              110001
            </p>
            <hr />
          </div>
        </div>
        <img
          src="https://payformservices.nttdatapay.com/logos/ladyirwin/adaptis-dark.webp"
          alt="NTT Data Logo"
          className="ntt-logo"
        />
      </header>
    </div>
  );
};

export default Header;
